import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/** Legacy route — redirects to User detail Activity tab */
const AnalyticsDashboard: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      navigate(`../users/${userId}?tab=activity`, { replace: true });
    } else {
      navigate('../users', { replace: true });
    }
  }, [userId, navigate]);

  return null;
};

export default AnalyticsDashboard;
